import React from "react";
import Button from "../../../components/ui/Button";
import { Title, SubTitle, ContainerCenter } from "./WaitingConfirmationCard.styles";

interface WaitingConfirmationCardProps {
  onTrackOrder: () => void;
}

export default function WaitingConfirmationCard({ onTrackOrder }: WaitingConfirmationCardProps) {
  return (
    <ContainerCenter>
      <Title>Seu pedido foi entregue ao estabelecimento</Title>
      <SubTitle>Obrigado pela preferência!</SubTitle>
      <Button variant="primary" full onClick={onTrackOrder}>
        Acompanhe seu pedido
      </Button>
    </ContainerCenter>
  );
}
